export default __webpack_public_path__ + "static/media/alert.c46f1c7d.svg";